import { createMachine } from 'xstate'

import type { Typegen0 } from './PmResourceStateCreateState.typegen'

export type TState = Typegen0['matchesStates']

export const PmResourceStateCreateState = createMachine({
  tsTypes: {} as import('./PmResourceStateCreateState.typegen').Typegen0,
  schema: {
    events: {} as { type: 'SAVE' },

    services: {} as {
      createResourceState: any
    },

    context: {} as {
      error: string | undefined
      errorDetails: string[] | undefined
    },
  },

  id: 'PmResourceStateCreateState',
  initial: 'default',

  context: {
    error: undefined,
    errorDetails: undefined,
  },

  states: {
    default: {
      on: {
        SAVE: 'save',
      },
    },

    save: {
      initial: 'saving',

      states: {
        saving: {
          invoke: {
            id: 'create-resource-state',
            src: 'createResourceState',
            onError: {
              target: 'failed',
              actions: (context, error) => {
                context.error = error.data.message
                context.errorDetails = error.data.details
              },
            },
            onDone: 'saved',
          },
        },

        failed: {
          on: {
            SAVE: 'saving',
          },
        },

        saved: {
          after: {
            1000: '#PmResourceStateCreateState.default',
          },

          exit: 'emitClose',
        },
      },
    },
  },
})
